export default "__VITE_ASSET__8186be2b__"